<template>
  <div class="min-h-screen bg-bochas-bg">
    <!-- Loading -->
    <section v-if="loading" class="py-24 sm:py-32 text-center">
      <div
        class="inline-block w-10 h-10 sm:w-12 sm:h-12 border-4 border-bochas-rojo border-t-transparent rounded-full animate-spin"
      ></div>
    </section>

    <!-- 404 -->
    <section
      v-else-if="!item"
      class="max-w-7xl mx-auto px-4 py-12 lg:py-24 text-center"
    >
      <h1 class="text-2xl sm:text-3xl font-bold text-white mb-3">
        No encontrado
      </h1>
      <p class="text-gray-400 mb-6">
        No encontramos la información de este espacio.
      </p>
      <router-link
        to="/alojamiento"
        class="btn-bochas-rojo text-sm sm:text-base"
      >
        Volver a alojamiento
      </router-link>
    </section>

    <!-- Detalle -->
    <article v-else class="pb-12 sm:pb-16">
      <!-- Banner -->
      <section class="py-12 lg:py-24 px-4 sm:px-6 lg:px-0 bg-degradado-bochas">
        <div class="max-w-4xl mx-auto text-center">
          <router-link
            to="/alojamiento"
            class="text-xs sm:text-sm text-white/80 hover:text-white mb-4 sm:mb-6 inline-block"
          >
            ← Volver a alojamiento
          </router-link>
          <div class="flex items-center justify-center mb-4">
            <IconFbochas :name="item.icon" :size="80" color="#fff" />
          </div>
          <h1
            class="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-3"
          >
            {{ item.title }}
          </h1>
        </div>
      </section>

      <!-- Contenido -->
      <section class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-0 py-8 sm:py-12">
        <p
          class="text-bochas-text-muted whitespace-pre-line leading-relaxed text-base sm:text-lg mb-8"
        >
          {{ item.description }}
        </p>

        <div v-if="item.images.length" class="mb-8 grid grid-cols-2 gap-3">
          <img v-for="(url, index) in item.images" :key="index" :src="url" :alt="item.title + ' ' + (index + 1)" loading="lazy" class="aspect-video w-full rounded-xl object-cover" />
        </div>
        <div
          v-if="item.features && item.features.length > 0"
          class="card-fbochas p-6 sm:p-10"
        >
          <h2 class="text-xl sm:text-2xl font-bold text-white mb-4">
            {{ item.featuresTitle }}
          </h2>
          <ul class="space-y-2">
            <li
              v-for="(feature, idx) in item.features"
              :key="idx"
              class="text-white flex items-start gap-2"
            >
              <span class="text-bochas-rojo mt-1">•</span>
              <span>{{ feature }}</span>
            </li>
          </ul>
        </div>

        <div v-if="item.contact" class="card-fbochas p-6 sm:p-10 mt-6">
          <div class="flex items-center gap-3 mb-4">
            <IconFbochas name="phoneCall" :size="28" class="text-bochas-rojo" />
            <h3 class="text-xl sm:text-2xl font-bold text-white">{{ content.contactTitle }}</h3>
          </div>
          <p class="text-white">{{ item.contact }}</p>
        </div>
      </section>
    </article>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import IconFbochas from "@/components/Icons/IconFbochas.vue";

import { crearAlojamientoContent, obtenerAlojamientoContent } from "@/services/siteSettings/alojamientoContentService";

const route = useRoute();
const loading = ref(true);
const content = ref(crearAlojamientoContent());
const item = computed(() => {
  const prefix = { "casa-del-bochofilo": "casa", "albergue-estudiantil": "albergue" }[route.params.slug];
  if (!prefix) return null;
  return {
    icon: prefix === "casa" ? "casa" : "graduationCap",
    title: content.value[prefix + "Title"],
    description: content.value[prefix + "Description"],
    features: content.value[prefix + "Features"],
    featuresTitle: content.value[prefix + "FeaturesTitle"],
    images: content.value[prefix + "Images"],
    contact: [content.value.address, content.value.neighborhood, content.value.city, content.value.phones, content.value.fax].filter(Boolean).join(" · "),
  };
});
onMounted(async () => {
  try {
    content.value = await obtenerAlojamientoContent();
  } catch (_) {
    // Conservar contenido original si la API no está disponible.
  } finally {
    loading.value = false;
  }
});
</script>
